/*@flow*/
// @ts-check
import { useDomSync } from './useDomSync';
import useMap from './useMap';
import useProjects from './useProjects';

export function InnerDiv({ children }) {
  useMap();
  useProjects();
  useDomSync();
  return children;
}
